import i18n from "i18n";

export const FeedbackTableHeader = (customCaptions) => {
	return [
		{
			id: 1,
			name: i18n.t("label.entityNumber", { entity: customCaptions?.feedback }),
			width: "20px",
		},
		{ id: 3, name: customCaptions?.feedbackStatus, width: "30px" },
		{ id: 5, name: customCaptions?.department },
		{ id: 6, name: customCaptions?.changeRequired, minWidth: "300px" },
		{ id: 7, name: `${customCaptions?.benefit}`, minWidth: "300px" },
		{ id: 10, name: customCaptions?.asset, width: "152px" },
		{ id: 12, name: i18n.t("label.createdDate"), minWidth: "170px" },
		{ id: 13, name: i18n.t("label.createdBy"), minWidth: "170px" },
		{
			id: 14,
			name: i18n.t("label.assignEntity", { entity: customCaptions?.position }),
			width: "60px",
		},
		{
			id: 15,
			name: i18n.t("label.assignEntity", { entity: customCaptions?.user }),
			minWidth: "170px",
		},
		{ id: 16, name: customCaptions?.classification, minWidth: "170px" },
		{ id: 17, name: customCaptions?.priority },
	];
};
export const FeedbackTableColumns = () => {
	return [
		"number",
		"feedbackStatusName",
		"siteDepartmentName",
		"changeRequired",
		"benefit",
		"siteAssetName",
		"createdDateTime",
		"displayName",
		"assignPositionName",
		"assignUserName",
		"feedbackClassificationName",
		"feedbackPriorityName",
	];
};
